document.addEventListener('DOMContentLoaded', function() {
  const imageElements = document.querySelectorAll('.gallery img');
  const interval = 10000; // 10 seconds

  function swapImages() {
    imageElements.forEach((image, index) => {
      const altImageId = `alternative_image${index + 1}`;
      const altImage = document.getElementById(altImageId);

      if (altImage && altImage.src) {
        const tempSrc = image.src;
        image.src = altImage.src;
        altImage.src = tempSrc;
      }
    });
  }

  setInterval(swapImages, interval);
});
